import React, {useEffect, useState} from 'react'


import {Button, Container, Tab, Tabs, Form, Badge, Alert} from 'react-bootstrap'
import {MdThumbDown, MdThumbUp} from 'react-icons/md'
import {useParams, useNavigate} from 'react-router-dom'
import Editor from 'react-simple-code-editor'
import Highlight, {defaultProps} from 'prism-react-renderer'
import vsDark from 'prism-react-renderer/themes/vsDark'
import vsLight from 'prism-react-renderer/themes/vsLight'
import {
    Input,
    Radio,
    Select,
    Textarea,
} from '../../../../common/inputs'
import {DualBoxData} from '../../../../common/inputs'
import ButtonWithIcon from '../../../../common/ButtonWithIcon'
import {useLocalStorage} from '../../../../../hooks/useLocalStorage.js'
import {Wrapper} from './styles/viewRaportForm.styles'
import RaportParamRepeater from "../ViewRaportyList/parts/RaportParamRepeater";
import {HeaderTitle} from "../../../../common/HeaderTitle.jsx";
import Api from "../../../../../api/api.js";


const ViewRaportForm = () => {


    const [theme, setTheme] = useLocalStorage('lsi_rap_theme', 'light')
    const {id} = useParams()
    const navigate = useNavigate()
    const statusy = [
        {id: 'projekt', value: 'projekt'},
        {id: 'aktualny', value: 'aktualny'},
        {id: 'archiwum', value: 'archiwum'},

    ]
    const styles = {
        rootDark: {
            boxSizing: 'border-box',
            fontFamily: '"Dank Mono", "Fira Code", monospace',
            ...vsDark.plain,
            fontSize: '1.1rem',
            minHeight: '12vh',
        },
        rootLight: {
            boxSizing: 'border-box',
            fontFamily: '"Dank Mono", "Fira Code", monospace',
            ...vsLight.plain,
            fontSize: '1.1rem',
            minHeight: '12vh',
            backgroundColor: '#f8f9fa',
        },
    }

    const [form, setForm] = useState({})
    const [mode, setMode] = useState('')
    const [errors, setErrors] = useState([])
    const [testResponse, setTestResponse] = useState('')

    const setFormState = (field, value) => {
        setForm((prev) => ({...prev, [field]: value}))
    }
    const highlight = (code, lang) => (
        <Highlight
            {...defaultProps}
            theme={theme === 'dark' ? vsDark : vsLight}
            code={code}
            title={'code'}
            language={lang}
        >
            {({_className, _style, tokens, getLineProps, getTokenProps}) => (
                <>
                    {tokens.map((line, i) => (
                        <div {...getLineProps({line, key: i})}>
                            {line.map((token, key) => (
                                <span {...getTokenProps({token, key})} />
                            ))}
                        </div>
                    ))}
                </>
            )}
        </Highlight>
    )
    const getData = () => {
        if (id === 'nowy') {
            return
        }

        Api(`oper/raporty/${id}`).then((res) => {
            if (res?.data?.status === 'success') {
                setForm(res?.data?.item)
            }

        })
    }

    const testQuery = () => {
        Api.post('oper/raporty/test-query', {query: form.sql_query, parametry: form.parametry}).then(
            (res) => {
                setErrors([])
                if (res.status === 422) {
                    setTestResponse(`BŁĄD!: ${res?.data?.message}`)
                    setErrors(res?.data?.errors)
                    setFormState('valid', 0)
                } else if (res?.data?.status === 'success') {
                    setTestResponse(JSON.stringify(res?.data?.result, null, 2))
                    setFormState('valid', 1)
                } else {
                    setFormState('valid', 0)
                    setTestResponse(`Błąd`)
                }
            }
        )
    }

    const save = () => {
        const payload = {
            ...form,
            ...(mode === 'new' ? {
                status: form?.status || 'projekt',
                valid: form?.valid ?? 0,
                uprawnienia: form?.uprawnienia || [],
                parametry: form?.parametry || [],
            } : {})
        }

        delete payload.user_id
        delete payload.params

        let method = mode === 'new' ? 'post' : 'put'
        Api[method](
            `oper/raporty/${mode === 'new' ? 'dodaj' : 'modyfikuj'}`,
            payload
        ).then((res) => {
            setErrors([])
            if (res.status === 422) {
                setErrors(res?.data?.errors)
            }
            if (res?.data?.status === 'success') {
                mode === 'new' && navigate(`/oper/raporty`)
            }
        })
    }
    const renderNav = () => (
        <div className={'d-flex gap-2 mt-3'}>
            <Button variant={'success'} onClick={() => save()}>
                {mode === 'new' ? 'ZAPISZ' : 'MODYFIKUJ'}
            </Button>
            <Button
                variant={'primary'}
                onClick={() => navigate('/oper/raporty')}
            >
                ANULUJ
            </Button>
            {!form?.valid && (
                <Badge className={'align-self-center text-black'} bg='info'>
                    Raport będzie dostępny dla użytkownika po poprawnym teście
                </Badge>
            )}
        </div>
    )

    useEffect(() => {
        setMode(id !== 'nowy' ? 'edit' : 'new')
        if (id) getData()
        // eslint-disable-next-line
    }, [])


    useEffect(() => {
        form?.parametry?.map((param) => {
            if (!Object.hasOwnProperty('value')) {
                return param.value = {[param.nazwa]: param.wartosc}
            }
        })
    }, [form.parametry])


    //return
    return (

        <Wrapper>
            <HeaderTitle
                breadcrumbLinks={[
                    {label: `Wszystkie raporty`, to: '/oper/raporty'},

                    {label: 'Dodawanie/edycja raportu'},
                ]}
                home
                destination={`/oper/raporty`}
                size={'fs-3'}
                nav
                title='Dodawanie/edycja raportu'/>
            <Container className='mb-3'>
                <Tabs
                    // justify
                    variant={'pills'}
                    defaultActiveKey='podstawowe'
                    id='raport_operator'
                >
                    <Tab

                        className={'mt-3'}
                        eventKey='podstawowe'
                        title='Dane podstawowe'
                    >
                        <Select
                            noEmpty
                            errorText={errors?.status?.[0]}
                            className={'mt-2'}
                            value={form?.status}
                            label={'Status'}
                            options={statusy}
                            onChange={(e) =>
                                setFormState('status', e.target.value)
                            }
                        />
                        <Input
                            className={'mt-2'}
                            label={'Nazwa'}
                            errorText={errors?.nazwa?.[0]}
                            value={form?.nazwa || ''}
                            onChange={(e) =>
                                setFormState('nazwa', e.target.value)
                            }
                        />

                        <Textarea
                            className={'mt-2'}
                            rows={3}
                            label={'Opis'}
                            value={form?.opis || ''}
                            onChange={(e) =>
                                setFormState('opis', e.target.value)
                            }
                            errorText={errors?.opis?.[0]}
                        />

                    </Tab>

                    <Tab
                        className={'mt-3'}
                        eventKey='zapytanie'
                        title='Zapytanie'
                    >
                        <div className={'d-flex mt-4 justify-content-between'}>
                            <Form.Label htmlFor={'editor1'} className={'fw-bold'}>
                                SQL query
                            </Form.Label>
                            {/*<Radio*/}
                            {/*    name='motyw'*/}
                            {/*    options={[*/}
                            {/*        {label: 'jasny motyw', value: 'light'},*/}
                            {/*        {label: 'ciemny motyw', value: 'dark'},*/}
                            {/*    ]}*/}
                            {/*    vertical={false}*/}
                            {/*    value={theme}*/}
                            {/*    onChange={(e) => setTheme(e.target.value)}*/}
                            {/*/>*/}
                        </div>
                        <Editor
                            aria-label={'sql query'}
                            value={form?.sql_query || ``}
                            onValueChange={(code) => {
                                setFormState('sql_query', code)
                                setFormState('valid', 0)
                            }}
                            highlight={(code) => highlight(code, 'sql')}
                            padding={10}
                            title={'SQL query'}
                            textareaClassName={'highligther'}
                            style={
                                theme === 'dark'
                                    ? styles.rootDark
                                    : styles.rootLight
                            }
                        />
                        {errors?.sql_query?.[0] && (
                            <Alert className={"p-1 w-100"} variant={"danger"}>
                                <div className={"ms-1"}> {errors?.sql_query?.[0]}</div>
                            </Alert>
                        )}

                        <RaportParamRepeater setFormState={setFormState} form={form}/>
                        <div className={'mt-5'}>
                            <div className={'d-flex gap-1'}>

                                <ButtonWithIcon
                                    readOnly={true}
                                    size={'sm'}
                                    variant={form?.valid ? 'success' : 'danger'}
                                    text={'Testuj zapytanie'}
                                    onClick={() => testQuery()}
                                    icon={
                                        form?.valid ? (
                                            <MdThumbUp/>
                                        ) : (
                                            <MdThumbDown/>
                                        )
                                    }
                                />

                            </div>
                        </div>

                        <Form.Label htmlFor={'editor2'} className={'mt-3 fw-bold'}>
                            Podgląd wyniku testu [LIMIT 1]
                        </Form.Label>
                        <Editor
                            id={'editor2'}
                            value={testResponse || 'Brak danych'}
                            highlight={(code) => highlight(code, 'json')}
                            padding={10}
                            aria-label={'Podgląd wyniku testu'}
                            textareaClassName={'highligther'}
                            style={
                                theme === 'dark'
                                    ? {
                                        ...styles.rootDark,
                                        fontSize: '.95rem',
                                    }
                                    : {
                                        ...styles.rootLight,
                                        fontSize: '.95rem',
                                        color: !form?.valid ? 'red' : null,
                                    }
                            }
                        />
                    </Tab>
                    <Tab
                        className={'mt-3'}
                        eventKey='uprawnienia'
                        title='Uprawnienia'
                    >
                        <DualBoxData
                            errorText={errors?.uprawnienia}
                            queryId={'oper_uprawnienia'}
                            dataEndpoint={`/oper/uzytkownicy/uprawnienia`}
                            value={form?.uprawnienia || []}
                            onChange={(e) => {
                                setFormState('uprawnienia', e)
                            }}
                        />
                    </Tab>
                </Tabs>
                {renderNav()}
            </Container>
        </Wrapper>
    )
}

export default ViewRaportForm
